import { IPlatform } from '../../models/advanced-platforms/iplatform-model';
import { PlatformsIds } from '../../enum/advanced-platforms/platforms-ids.enum';
import { environment } from '../../../src/environments/environment'

export const platformData: IPlatform[] = [
    {
        id: PlatformsIds.ToroTraderProfit,
        title: 'Profit Toro Trader',
        subTitle: 'Toro Trader',
        queryParam: 'toro-profit',
        subscriptionStatus: null,
        isBlockedBuyPlatform: false,
        automatedSubscription: true,
        automatedCancelation: true,
        isPendingSubscription: false,
        requiresRegistration: true,
        cancelSubscriptionUrl: 'https://forms.gle/NvrNzgXL4aCTMWg48',
        card: {
            srcImage: 'toro-trader.png',
            tag: 'Recomendado',
            resum: 'Plataforma de trading mais utilizada e melhor avaliada. Com tudo que o Trader precisa: replay de mercado, simulador e trading direto no gráfico.',
            activatedResum: {
                freeText:
                    'Plataforma de trading mais utilizada e melhor avaliada. Com tudo que o Trader precisa: replay de mercado, simulador e trading direto no gráfico.',
                routerLink: '/plataformas/toro-trader',
                onboardingButtonText: 'Explore o Toro Trader',
                textLink: 'como começar com o Profit Toro Trader',
            },
            periodTest: [
                {
                    freeText: '100% grátis para você operar.',
                },
            ],
            subscribeButtonText: 'Ativar Toro Trader',
            guideLink:
                'https://cdn.toroinvestimentos.com.br/corretora/documents/manual-de-uso-e-funcionalidades-toro-trader.pdf',
        },
        page: {
            freeText: '100% grátis para você operar.',
            cancellationRule:
                'Após 30 dias seguidos sem operar, a plataforma é desativada automaticamente.',
        },
        modal: {
            messages: [
                '<p><strong>Grátis:</strong> operando a partir de 1 minicontrato no mês.</p><p> <strong>Ou:</strong>  R$ 39,90/mês [apenas se você não operar 1 mini contrato por mês após o período de teste].</p>',
                '<p><strong>Período de teste:</strong> 30 dias.</p><p>Válido apenas para a primeira contratação. Após o período de teste, a ativação do plano é feita automaticamente.</p>',
                `<p><strong>Forma de pagamento:</strong></p><p>Grátis ou débito automático na sua conta ${ environment.isNewBrand ? "Santander Corretora" : "Toro" }, todo 5º dia útil do mês.Para períodos de uso da plataforma menores que um mês, será cobrado um valor proporcional.</p>`,
            ],
            attentionPoint:
                `Nos meses que você não operar o mínimo de minicontratos, o valor da mensalidade será debitado automaticamente da sua conta ${ environment.isNewBrand ? "Santander Corretora" : "Toro" }.`,
        },
        errorModals: {
            fillingRegistrationError: {
                titleMessage: 'Finalize seu cadastro para acessar a plataforma',
                bodyMessage:
                    'Seu cadastro ainda não foi concluído. Clique no botão abaixo para continuar de onde parou.',
                buttonMessage: 'Finalizar cadastro',
            },
            pendingRegistrationError: {
                titleMessage: 'Identificamos pendências no seu cadastro',
                bodyMessage:
                    'Não foi possível ativar a plataforma. Veja o que pode estar causando esse problema clicando no botão abaixo.',
                buttonMessage: 'Saiba mais',
            },
            userAccountNotActiveError: {
                titleMessage:
                    'Você precisa transferir recursos antes de assinar o Profit Toro Trader.',
                bodyMessage:
                    `Assim que você tiver saldo na sua Conta ${ environment.isNewBrand ? "Santander Corretora" : "Toro" } o Profit Toro Trader estará disponível para você assinar.`,
                buttonMessage: 'Transferir recursos',
            },
        },
        successModals: {
            successSubscription: {
                titleMessage: 'O Profit Toro Trader foi ativado com sucesso!',
                bodyMessage: `Clique no botão abaixo para fechar e ver
                    <b>como configurar e instalar a plataforma</b> no seu
                    computador.`,
                buttonMessage: 'Saiba mais sobre o Profit Toro Trader',
            },
        },
        warningModals: {
            signatureDuplication: {
                titleMessage:
                    'Importante: seu Profit Pro será desativado ao ativar o Profit Toro Trader.',
                bodyMessage: `<b>Se você tem posições abertas no Profit Pro</b>,
                você poderá encerrá-las usando o site da ${ environment.isNewBrand ? "Santander Corretora" : "Toro" } em `,
                buttonMessage: 'Ativar Profit Toro Trader',
            },
            automaticPendingRegistration: {
                titleMessage:
                    `Pronto! Assim que seu cadastro na ${ environment.isNewBrand ? "Santander Corretora" : "Toro" } for concluído a plataforma vai ser ativada.`,
                bodyMessage: `Quando estiver tudo certo, você vai receber um e-mail com a
                confirmação da ativação do Profit Toro Trader.`,
                buttonMessage: 'Entendi',
            },
        },
    },
    {
        id: PlatformsIds.ToroTraderMobile,
        title: 'Toro Trader Mobile',
        queryParam: 'toro-trader-mobile',
        subscriptionStatus: null,
        isBlockedBuyPlatform: false,
        automatedSubscription: false,
        automatedCancelation: false,
        subscriptionUrl: '/plataformas/toro-trader-mobile',
        requiresRegistration: false,
        card: {
            srcImage: 'toro-trader-mobile.png',
            resum: 'O melhor do Profit Toro Trader na versão para smartphone 100% grátis: Chart Trading, Super DOM, acompanhamento de carteira e mais.',
            periodTest: [
                {
                    freeText: 'Totalmente grátis.',
                },
            ],
            subscribeButtonText: 'Conhecer e baixar o app',
            viewMoreLink:
                'https://conteudos.toroinvestimentos.com.br/como-comecar-com-o-toro-trader-mobile',
            guideLink:
                'https://cdn.toroinvestimentos.com.br/corretora/documents/manual-de-uso-e-funcionalidades-toro-trader-mobile.pdf',
        },
    },
    {
        id: PlatformsIds.HomeBrokerClassic,
        title: 'Home Broker Clássico',
        queryParam: 'home-broker-classico',
        subscriptionStatus: null,
        isBlockedBuyPlatform: false,
        automatedSubscription: false,
        automatedCancelation: false,
        requiresRegistration: false,
        opensInAnotherDomain: true,
        subscriptionUrl: '/plataformas/acessar-homebroker',
        card: {
            srcImage: 'home-broker-classic.png',
            isNew: false,
            resum: 'Acesse todas as funcionalidades de um Home Broker tradicional, com gráficos completos e boletas com opções avançadas.',
            periodTest: [
                {
                    freeText: 'Totalmente grátis.',
                },
            ],
            subscribeButtonText: 'Abrir Home Broker',
            viewMoreLink:
                'https://conteudos.toroinvestimentos.com.br/como-comecar-com-o-toro-trader-mobile',
            guideLink:
                'https://cdn.toroinvestimentos.com.br/corretora/documents/manual-de-uso-e-funcionalidades-home-broker-classico.pdf',
        },
    },
    {
        id: PlatformsIds.ProfitPro,
        title: 'Profit Pro',
        queryParam: 'profit-pro',
        subscriptionStatus: null,
        isBlockedBuyPlatform: false,
        automatedSubscription: true,
        automatedCancelation: true,
        cancelSubscriptionUrl:
            'https://docs.google.com/forms/d/e/1FAIpQLSecP2nSAGQGMt5kZJ97gtsJRBvgWV4YN8LEV9cZJGAZ6jZs-Q/viewform',
        requiresRegistration: true,
        card: {
            srcImage: 'profit-pro.jpg',
            tag: 'Profissionais de fluxo',
            isNew: false,
            resum: 'Indicado para Traders que tomam decisões utilizando o Super DOM (leitura de fluxo de ordens).',
            activatedResum: {
                freeText:
                    'Indicado para Traders que tomam decisões utilizando o Super DOM (leitura de fluxo de ordens).',
                routerLink: '/plataformas/profit-pro',
                onboardingButtonText: 'Explore o Profit Pro',
                textLink: 'Veja como instalar o Profit Pro.',
            },
            periodTest: [
                {
                    freeText: 'Grátis operando 4 minicontratos a cada 30 dias.',
                    priceText: 'Ou R$ 119,90 ao completar 30 dias sem operar o mínimo.',
                },
            ],
            subscribeButtonText: 'Assinar Profit Pro',
            viewMoreLink:
                'https://conteudos.toroinvestimentos.com.br/plataformas/profit-pro',
            guideLink:
                'https://cdn.toroinvestimentos.com.br/corretora/documents/manual-de-uso-e-funcionalidades-profit-pro.pdf',
        },
        page: {
            freeText: 'Grátis operando 4 minicontratos a cada 30 dias.',
            cancellationRule:
                'Ao completar 30 dias sem operar ao menos 4 minicontratos, será cobrado R$ 119,90 e sua assinatura será cancelada.',
        },
        subscriptionModal: {
            freeLogo: false,
            srcLogo:'profit-pro-logo.png',
            sidebarText: 'Use o Profit Pro em:',
            footerMobileText: 'Use o Profit Pro em:',
            availableIcons: {
                iconPath:
                    'assets/images/advanced-platforms/icons/windows_light_blue.svg',
                iconPathApple:
                    'assets/images/advanced-platforms/icons/cell_phone_apple.svg',
                iconPathAndroid:
                    'assets/images/advanced-platforms/icons/cell_phone_Android.svg',
            },
            priceText: 'Sempre que <strong class="text-strong">operar ao menos 4 minicontratos</strong> a cada 30 dias.',
        conditionalPriceText: `Ao completar 30 dias sem operar 4 minicontratos, existe a cobrança de <strong class="text-strong">  R$ 119,90</strong> debitado na sua Conta ${ environment.isNewBrand ? "Santander Corretora" : "Toro" }.`,
            detailHtml: 'Indicado para Traders que tomam decisões utilizando o <b>Super DOM</b> (leitura de fluxo de ordens).',
            confirmButtonText: 'Confirmar assinatura',
            agreementText: `Declaro que li e concordo com o `,
        },
        errorModals: {
            fillingRegistrationError: {
                titleMessage: 'Finalize seu cadastro para assinar a plataforma',
                bodyMessage:
                    'Seu cadastro ainda não foi concluído. Clique no botão abaixo para continuar de onde parou.',
                buttonMessage: 'Finalizar cadastro',
            },
            pendingRegistrationError: {
                titleMessage: 'Identificamos pendências no seu cadastro',
                bodyMessage:
                    'Não foi possível assinar a plataforma. Veja o que pode estar causando esse problema clicando no botão abaixo.',
                buttonMessage: 'Saiba mais',
            },
            insufficientFundsError: {
                infoModal: {
                    titleMessage: 'É necessário ter pelo menos R$250,00 na sua conta para assinar o Profit Pro.',
                    bodyMessage: `Você pode transferir recursos <strong>ou começar a usar agora mesmo a Plataforma Profit Toro Trader</strong>, que não exige saldo mínimo para assinar.`,
                    buttonMessage: 'Transferir recursos',
                },
                activateAnotherPlatformButton: 'Ir para Profit Toro Trader',
            },
        },
        successModals: {
            successSubscription: {
                titleMessage: 'O Profit Pro foi assinado com sucesso!',
                bodyMessage: `Em breve <b>você vai receber um e-mail</b> com o passo a passo
                    de como instalar e começar a operar com o Profit Pro. `,
                buttonMessage: 'Veja como dar os primeiros passos',
            },
        },
        warningModals: {
            signatureDuplication: {
                titleMessage:
                    'Importante: seu Profit Toro Trader será desativado ao assinar o Profit Pro.',
                bodyMessage: `<b>Se você tem posições abertas no Profit Toro Trader</b>,
                você poderá encerrá-las usando o site da ${ environment.isNewBrand ? "Santander Corretora" : "Toro" } em `,
                buttonMessage: 'Ativar Profit Pro',
            },
        },
    },
    {
        id: PlatformsIds.ScalperPro,
        title: 'Scalper Pro',
        queryParam: 'scalper-pro',
        subscriptionStatus: null,
        isBlockedBuyPlatform: false,
        automatedSubscription: true,
        automatedCancelation: true,
        subscriptionUrl: '',
        requiresRegistration: false,
        cancelSubscriptionUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSekLmHeOAoKcVlGIZCGDzHCsBZlKDcThqSMaS4DzPjO-MuAvg/viewform',
        isPaid: true,
        card: {
            isNew: true,
            srcImage: 'scalper-pro.png',
            resum:
                'Acesse o que há de melhor em leitura e análise de dados do mercado. Opere com mais confiança nas entradas, saídas e segurança no stop.',
            activatedResum: {
                freeText: 'Acesse o que há de melhor em leitura e análise de dados do mercado. Opere com mais confiança nas entradas, saídas e segurança no stop.',
                deactivateText: 'Cancelar Scalper Pro',
                onboardingButtonText: 'Explorar o seu Scalper Pro',
                faqLink: 'https://ajuda.nelogica.com.br/hc/pt-br/articles/15708872922907-O-que-%C3%A9-Scalper-Pro',
            },
            periodTest: [
                {
                    customText: '<span>R$ 119,90</span><sub style="font-size: 10px;">por mês</sub>',
                    priceText: 'Assine a plataforma que todo Trader quer ter.',
                },
                {
                    customText: '',
                    priceConditionText: '',
                },
            ],
            subscribeButtonText: 'Assinar Scalper Pro',
            guideLink:
                'https://cdn.toroinvestimentos.com.br/corretora/documents/manual-de-uso-e-funcionalidades-scalper-pro.pdf',
        },
        subscriptionModal: {
            srcLogo: 'scalper-pro-modal.png',
            freeLogo: false,
            sidebarText: 'Use o Scalper Pro em:',
            footerMobileText: 'Use o Scalper Pro em:',
            availableIcons: {
                iconPath: 'assets/images/advanced-platforms/icons/windows_light_blue.svg',
            },
            priceText: 'Assine a plataforma que todo Trader quer ter.',
            priceValue:'R$ 119,90 por mês',
            detail: {
                title: 'Informações sobre o pagamento da assinatura:',
                list: [
                    `<strong>A cobrança é feita em débito automático</strong> na sua Conta ${ environment.isNewBrand ? "Santander Corretora" : "Toro" } todo 5º dia útil do mês.`,
                    `<strong>O 1º mês será cobrado proporcionalmente</strong> considerando a data da ativação da assinatura.`,
                ],
            },
            confirmButtonText: 'Confirmar assinatura',
            agreementText: `Declaro que li e concordo com o `,
        },
        successModals: {
            successSubscription: {
                titleMessage: 'O Scalper Pro foi assinado com sucesso!',
                bodyMessage: `Em breve <b>você vai receber um e-mail</b> com as orientações para instalar e começar a operar com o Scalper Pro.`,
                buttonMessage: 'Saiba mais sobre a plataforma',
                faqLink: 'https://ajuda.nelogica.com.br/hc/pt-br/articles/15708872922907-O-que-%C3%A9-Scalper-Pro'
            },
        },
        warningModals: {
            signatureDuplication: {
                titleMessage: 'Importante: seu Profit Toro Trader será desativado ao ativar o Scalper Pro',
                bodyMessage: `<b>Se você tem posições abertas no Profit Toro Trader</b>,
                você poderá encerrá-las usando o site da ${ environment.isNewBrand ? "Santander Corretora" : "Toro" } em `,
                buttonMessage: 'Ativar Profit Ultra',
            },
        },
        errorModals: {
            fillingRegistrationError: {
                titleMessage: 'Finalize seu cadastro para assinar a plataforma',
                bodyMessage: 'Seu cadastro ainda não foi concluído. Você pode continuar de onde parou.',
                buttonMessage: 'Finalizar cadastro',
            },
            pendingRegistrationError: {
                titleMessage: 'Identificamos pendências no seu cadastro',
                bodyMessage: 'Não foi possível assinar a plataforma. Saiba o que pode estar causando esse problema.',
                buttonMessage: 'Saiba mais',
            },
            insufficientFundsError: {
                infoModal: {
                    titleMessage: 'É necessário ter pelo menos R$119,90 na sua conta para assinar o Scalper Pro',
                    bodyMessage: 'Esse valor é apenas uma garantia, a cobrança proporcional ocorrerá até o próximo 5º dia útil. Você pode transferir recursos ou <strong>começar a usar agora mesmo a Plataforma Profit Toro Trader</strong>, que não exige saldo mínimo para assinar.',
                    buttonMessage: 'Transferir recursos',
                },
                activateAnotherPlatformButton: 'Ir para Profit Toro Trader',
            },
        },
    },
    {
        id: PlatformsIds.ProfitUltra,
        title: 'Profit Ultra',
        queryParam: 'profit-ultra',
        subscriptionStatus: null,
        isBlockedBuyPlatform: false,
        automatedSubscription: true,
        automatedCancelation: true,
        subscriptionUrl: '',
        requiresRegistration: false,
        cancelSubscriptionUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSf-CjH7aH0TS5US-zAdTuAtIyqnOpTIf2q3LTRPa_Oe9B7Rng/viewform',
        isPaid: true,
        card: {
            isNew: false,
            srcImage: 'profit-ultra.png',
            resum:
                'A plataforma Profit mais completa da Nelogica. Tenha todas as ferramentas e indicadores do Profit Pro com recursos novos e mais avançados.',
            activatedResum: {
                freeText: 'A plataforma Profit mais completa da Nelogica. Tenha todas as ferramentas e indicadores do Profit Pro com recursos novos e mais avançados.',
                deactivateText: 'Cancelar assinatura',
                onboardingButtonText: 'Saiba mais',
                faqLink: 'https://ajuda.nelogica.com.br/hc/pt-br/sections/16512543629211-Profit-Ultra',
            },
            periodTest: [
                {
                    customText: '<span>R$ 299</span><sub style="font-size: 10px;">por mês</sub>',
                    priceText: 'Assine a plataforma mais completa da Nelogica.',
                },
                {
                    customText: '',
                    priceConditionText: '',
                },
            ],
            subscribeButtonText: 'Assinar Profit Ultra',
            viewMoreLink:
                'https://conteudos.toroinvestimentos.com.br/plataformas/profit-pro',
            guideText: 'Ver funcionalidades e Manual de Uso',
            guideLink:
                'https://cdn.toroinvestimentos.com.br/corretora/documents/manual-de-uso-e-funcionalidades-profit-ultra.pdf',
        },
        subscriptionModal: {
            freeLogo: false,
            sidebarText: 'Use o Profit Ultra em:',
            footerMobileText: 'Use o Profit Ultra em:',
            availableIcons: {
                iconPath: 'assets/images/advanced-platforms/icons/windows_light_blue.svg',
                iconPathApple: 'assets/images/advanced-platforms/icons/apple_mac.svg',
                iconPathIos: 'assets/images/advanced-platforms/icons/cell_phone_apple.svg',
                iconPathAndroid: 'assets/images/advanced-platforms/icons/cell_phone_Android.svg',
            },
            priceText: 'Assine a plataforma mais completa da Nelogica.',
            priceValue:'R$ 299 por mês',
            detail: {
                title: 'Informações sobre o pagamento da assinatura:',
                list: [
                    `<strong>A cobrança é feita em débito automático</strong> na sua Conta ${ environment.isNewBrand ? "Santander Corretora" : "Toro" } todo 5º dia útil do mês.`,
                    `<strong>O 1º mês será cobrado proporcionalmente</strong> considerando a data da ativação da assinatura.`,
                ],
            },
            confirmButtonText: 'Confirmar assinatura',
            agreementText: `Ao confirmar a assinatura, você declara que leu e concorda com o`,
        },
        successModals: {
            successSubscription: {
                titleMessage: 'O Profit Ultra foi assinado com sucesso!',
                bodyMessage: `Em breve <b>você vai receber um e-mail</b> com o passo a passo
                    de como instalar e começar a operar com o Profit Ultra. `,
                buttonMessage: 'Fechar',
                faqMessage: 'Conheça um pouco mais o Profit Ultra',
                faqLink: 'https://ajuda.nelogica.com.br/hc/pt-br/sections/16512543629211-Profit-Ultra'
            },
        },
        warningModals: {
            signatureDuplication: {
                titleMessage: 'Importante: seu Profit Toro Trader será desativado ao ativar o Profit Ultra',
                bodyMessage: `<b>Se você tem posições abertas no Profit Toro Trader</b>,
                você poderá encerrá-las usando o site da ${ environment.isNewBrand ? "Santander Corretora" : "Toro" } em `,
                buttonMessage: 'Ativar Profit Ultra',
            },
        },
        errorModals: {
            fillingRegistrationError: {
                titleMessage: 'Finalize seu cadastro para ativar a plataforma',
                bodyMessage: 'Seu cadastro ainda não foi concluído. Clique no botão abaixo para continuar de onde parou.',
                buttonMessage: 'Finalizar cadastro',
            },
            pendingRegistrationError: {
                titleMessage: 'Identificamos pendências no seu cadastro',
                bodyMessage: 'Não foi possível ativar a plataforma. Veja o que pode estar causando esse problema clicando no botão abaixo. ',
                buttonMessage: 'Saiba mais',
            },
            insufficientFundsError: {
                infoModal: {
                    titleMessage: 'É necessário ter pelo menos R$299 na sua conta para assinar o Profit Ultra',
                    bodyMessage: 'Esse valor é apenas uma garantia, a cobrança proporcional ocorrerá até o próximo 5º dia útil. Você pode transferir recursos ou <strong>começar a usar agora mesmo a Plataforma Profit Toro Trader</strong>, que não exige saldo mínimo para assinar.',
                    buttonMessage: 'Transferir recursos',
                },
                activateAnotherPlatformButton: 'Ativar Profit Toro Trader',
            },
        },
    },
    {
        id: PlatformsIds.StrategyAutomation,
        title: 'Automação de Estratégias',
        queryParam: 'strategy-automation',
        subscriptionStatus: null,
        isBlockedBuyPlatform: false,
        automatedSubscription: true,
        automatedCancelation: true,
        subscriptionUrl: '',
        requiresRegistration: false,
        isPaid: true,
        card: {
            srcImage: 'strategy-automation.png',
            resum: 'Módulo integrado ao Profit Pro que automatiza suas estratégias. Crie robôs e programe suas operações de forma 100% automatizada.',
            periodTest: [
                {
                    customText: '<span>A partir de<br/>R$ 62,99 por mês</span>',
                    priceText: 'Ative este módulo no seu Profit Pro.',
                },
                {
                    customText: '',
                    priceConditionText: '',
                },
            ],
            subscribeButtonText: 'Saiba mais',
            guideText: 'Ver funcionalidades e Manual de Uso',
            guideLink:
                'https://cdn.toroinvestimentos.com.br/corretora/documents/manual-de-uso-e-funcionalidades-automacao-estrategias-nelogica.pdf',
        },
    },
    {
        id: PlatformsIds.Akeloo,
        title: 'Akeloo - Calculadora de I.R.',
        queryParam: 'akeloo',
        subscriptionStatus: null,
        isBlockedBuyPlatform: false,
        isPaid: true,
        automatedSubscription: true,
        automatedCancelation: false,
        subscriptionUrl: '',
        requiresRegistration: false,
        card: {
            srcImage: 'akeloo.png',
            resum: 'A calculadora de I.R. da Nelogica. Completa com tudo o que você precisa para declarar seu I.R.: dividendos, JCPs, ativos, criptomoedas e mais.',
            periodTest: [
                {
                    customText: 'Plano básico<br/>grátis',
                    priceText: 'Plano inicial gratuito e plano Pro com a solução completa.',
                },
                {
                    customText: '',
                    priceConditionText: '',
                },
            ],
            activatedResum: {
                freeText: 'A calculadora de I.R. da Nelogica. Completa com tudo o que você precisa para declarar seu I.R.: dividendos, JCPs, ativos, criptomoedas e mais.',
                onboardingButtonText: 'Acesse sua conta',
                faqLink: 'https://app.akeloo.com.br/login',
            },
            subscribeButtonText: 'Saiba mais',
            guideText: 'Ver funcionalidades e Manual de Uso',
            guideLink:
                'https://cdn.toroinvestimentos.com.br/corretora/documents/manual-de-uso-e-funcionalidades-akeloo-nelogica.pdf',
        },
        errorModals: {
            fillingRegistrationError: {
                titleMessage: 'Finalize seu cadastro para ativar a plataforma',
                bodyMessage: 'Seu cadastro ainda não foi concluído. Clique no botão abaixo para continuar de onde parou.',
                buttonMessage: 'Finalizar cadastro',
            },
            pendingRegistrationError: {
                titleMessage: 'Identificamos pendências no seu cadastro',
                bodyMessage: 'Não foi possível ativar a plataforma. Veja o que pode estar causando esse problema clicando no botão abaixo.',
                buttonMessage: 'Saiba mais',
            },
        },
    },
    {
        id: PlatformsIds.IRpage,
        title: 'Mycapital - Calculadora de I.R.',
        queryParam: 'mycapital',
        subscriptionStatus: null,
        isBlockedBuyPlatform: false,
        automatedSubscription: false,
        automatedCancelation: false,
        subscriptionUrl: '',
        requiresRegistration: false,
        isPaid: true,
        card: {
            srcImage: 'mycapital.png',
            resum: `Simplifique sua declaração de Imposto de Renda de Bolsa. Com geração de DARFs e importação automática das suas operações com a ${ environment.isNewBrand ? "Santander Corretora" : "Toro" }.`,
            periodTest: [
                {
                    customText:
                        '<span>R$ 32,20</span><sub style="font-size: 10px;">por mês</sub>',
                    priceText:
                        'Acesso a todas as funcionalidades da MyCapital.',
                },
                {
                    customText: '',
                    priceConditionText: '',
                },
            ],
            subscribeButtonText: 'Acessar ferramenta',
            guideText: 'Saiba mais',
            guideLink: '/plataformas/calculadora-de-ir',
        },
    },
];
